import React from 'react'

const WebDev = () => {
  return (
    <>
      <h1>Welcome to Web Development Component</h1>
    </>
  )
}

export default WebDev
